import Rest from '../Rest'

export default class TeacherRevenueService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/teacher_revenue'

  static build(vs = null) {
    return new this(this.resource, null, vs)
  }
}
